import {
  destroy,
} from './index';

export const logout = () => destroy('/api/v1/logout', { skipAdminPrefix: true });
